// Generated file : do not modify
export enum NotifDefTypes
{
  NONE = 0,
  INFO,
  ACTION
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Definition des notifications
export default class NotifDef  {
  // Identifiant unique
  public id: number;
  // Code de la notification
  public code: string;
  // Description
  public titre: string;
  // Contexte de la notification
  public contexte: string;
  // Libellé de la notification
  public label: string;
  // Détail de la notification
  public detail: string;
  // Email Id
  public emailId: number;
  // Sms Id
  public smsId: number;
  // Masque du profil destinataire
  public profil: number;
  // Type de notification
  public type: NotifDefTypes;
  // Objet de rattachement
  public objType: ObjTypes;
  // module associé
  public module: string;
  // fiche associée
  public fiche: string;
  // section associée
  public section: string;
  // Publi context
  public publiContext: string;
  // Contexte de la notification
  public contexteHtmlId: number;
  // Libellé de la notification
  public labelHtmlId: number;
  // Détail de la notification
  public detailHtmlId: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;

  constructor() {
    this.id = 0;
    this.code = '';
    this.titre = '';
    this.contexte = '';
    this.label = '';
    this.detail = '';
    this.emailId = 0;
    this.smsId = 0;
    this.profil = 0;
    this.type = NotifDefTypes.NONE;
    this.objType = ObjTypes.NONE;
    this.module = '';
    this.fiche = '';
    this.section = '';
    this.publiContext = '';
    this.contexteHtmlId = 0;
    this.labelHtmlId = 0;
    this.detailHtmlId = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
  }

  public static fromJson (obj: NotifDef): NotifDef {
    const newNotifDef: NotifDef = new NotifDef();
    newNotifDef.id = obj.id;
    newNotifDef.code = obj.code;
    newNotifDef.titre = obj.titre;
    newNotifDef.contexte = obj.contexte;
    newNotifDef.label = obj.label;
    newNotifDef.detail = obj.detail;
    newNotifDef.emailId = obj.emailId;
    newNotifDef.smsId = obj.smsId;
    newNotifDef.profil = obj.profil;
    newNotifDef.type = obj.type;
    newNotifDef.objType = obj.objType;
    newNotifDef.module = obj.module;
    newNotifDef.fiche = obj.fiche;
    newNotifDef.section = obj.section;
    newNotifDef.publiContext = obj.publiContext;
    newNotifDef.contexteHtmlId = obj.contexteHtmlId;
    newNotifDef.labelHtmlId = obj.labelHtmlId;
    newNotifDef.detailHtmlId = obj.detailHtmlId;
    newNotifDef.canUpdate = obj.canUpdate;
    newNotifDef.canDelete = obj.canDelete;
    newNotifDef.display = obj.display;
    return newNotifDef;
  }

  public toJsonNotifDef (): string {
    const json = {
      code: this.code,
      titre: this.titre,
      contexte: this.contexte,
      label: this.label,
      detail: this.detail,
      emailId: this.emailId,
      smsId: this.smsId,
      profil: this.profil,
      type: this.type,
      objType: this.objType,
      module: this.module,
      fiche: this.fiche,
      section: this.section,
      publiContext: this.publiContext,
      contexteHtmlId: this.contexteHtmlId,
      labelHtmlId: this.labelHtmlId,
      detailHtmlId: this.detailHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
    }
    return JSON.stringify(json);
  }

  public fromNotifDef (obj: NotifDef): void {
    this.id = obj.id;
    this.code = obj.code;
    this.titre = obj.titre;
    this.contexte = obj.contexte;
    this.label = obj.label;
    this.detail = obj.detail;
    this.emailId = obj.emailId;
    this.smsId = obj.smsId;
    this.profil = obj.profil;
    this.type = obj.type;
    this.objType = obj.objType;
    this.module = obj.module;
    this.fiche = obj.fiche;
    this.section = obj.section;
    this.publiContext = obj.publiContext;
    this.contexteHtmlId = obj.contexteHtmlId;
    this.labelHtmlId = obj.labelHtmlId;
    this.detailHtmlId = obj.detailHtmlId;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
  }

  public compareNotifDef (value: NotifDef): boolean {
    return (this.toJsonNotifDef() == value.toJsonNotifDef());
  }

  public cloneNotifDef (): NotifDef {
    return NotifDef.fromJson(this);
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/notifdefs/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/notifdefs/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<NotifDef> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/NotifDefs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = NotifDef.fromJson(listData.reccords[0] as NotifDef);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(notifDefs: NotifDef[]) {
  }
}
